module.exports = __webpack_public_path__ + "static/media/education.543cbd09.jpg";